import axios from '../../config/axios';
import config from '../../config/api';
import { setSnackbar } from './SnackbarAction';


export const getProcessorConnections = (data) => ({
    type: 'GET_PROCESSORCONNECTIONS',
    data
})

export const getFilteredData = (data) => ({
    type: 'FILTER_CONNECTIONS',
    data
})

export const fetchProcessorConnections = () => {
    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/connection/getAllConnections`).then(response => {
            if (response.status === 200) {
                dispatch(getProcessorConnections(response.data));
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong, Try again'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong'))
        })
    }
}

export const filteredData = (data) => {
    return function (dispatch) {
        dispatch(getFilteredData(data))
    }
}


export const addProcessorConnection = (body) => {
    return function (dispatch) {
        console.log('Fetching Processor Models')
        axios.post(`${config.api.FETCH_URL}/connection/addConnection`, body).then(response => {
            if (response.status === 200 || response.status === 201) {
                dispatch(setSnackbar(true, 'success', 'Added Successfully'))
                dispatch(fetchProcessorConnections())
            } else {
                dispatch(setSnackbar(true, 'error', 'Something Went Wrong, Try again'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Something Went Wrong, Try again'))
        })
    }
}